(() => {
    const initStateReady = () => {
        document.body.addEventListener('click', function (event) {
            if (event.target.classList.contains('dropdownButton')) {
                toggleDropdown(event.target);
            }
        });
    };

    const toggleDropdown = (event) => {
        event.classList.toggle('active-btn-color');
        document.querySelector('#' + event.getAttribute('data-dropdown-id')).classList.toggle('show');
        event.querySelector('#plus').classList.toggle('hide');
        event.querySelector('#close').classList.toggle('hide');

        let searchFormFilter = event.closest('.dropdown');
        if (document.querySelector('#' + event.getAttribute('data-dropdown-id')).classList.contains('show')) {
            let newHeight = document.querySelector('#' + event.getAttribute('data-dropdown-id')).offsetHeight;
            if (newHeight < 100) {
                newHeight = 100;
            } else {
                newHeight = newHeight + 37;
            }
            searchFormFilter.style.marginBottom = newHeight + 'px';
        } else {
            searchFormFilter.style.marginBottom = '5px';
        }
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') {
            return;
        }

        initStateReady();
    });
})();
